import { Counter } from './counter';
import { TimeSpanUtils } from './time-span-utils';

export class MessageBusTransportStats {

    private readonly created: number;
    private transactionsPerMinute: number;

    lastActivity: number;
    transactions: Counter;

    constructor() {
        const now: number = new Date().getTime();
        this.created = now;
        this.lastActivity = now;
        this.transactions = new Counter();
        this.transactionsPerMinute = 0;
    }

    update(): void {
        const minutes: number = TimeSpanUtils.MsToMinutes(Date.now() - this.created);
        this.transactionsPerMinute = this.transactions.value() / minutes;
    }
}


